export const enum BoxTextAlign {
    LEFT = "left",
    CENTER = "center",
    RIGHT = "right",
}
